import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { BACKEND_URL } from '../config/api';

/**
 * Custom hook for authentication in admin pages
 * Handles auth check and redirect on mount
 * @param {string} requiredRole - Required user role ('admin', 'employer', 'tradesperson')
 * @returns {{ user: object|null, loading: boolean }}
 */
export function useAuth(requiredRole = null) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    let isMounted = true;
    
    const checkAuth = async () => {
      try {
        const response = await axios.get(`${BACKEND_URL}/api/auth/me`, {
          withCredentials: true
        });
        
        if (!isMounted) return;
        
        // Check role if required
        if (requiredRole && response.data.user_type !== requiredRole) {
          navigate('/login');
          return;
        }
        
        setUser(response.data);
      } catch (_error) {
        if (isMounted) {
          navigate('/login');
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    checkAuth();
    
    return () => {
      isMounted = false;
    };
  }, [navigate, requiredRole]);

  return { user, loading, setUser };
}

export default useAuth;
